import React from "react";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { ChevronDown } from "lucide-react";
import { PERIODS } from "@/components/ResultsParts";

export const rangeLabel = (days, today = moment()) => {
  const end = moment(today);
  const start = moment(today).subtract(days - 1, "days");
  const startFormat = start.isSame(end, "year") ? "MMM D" : "MMM D, YYYY";
  const nb = (text) => text.replace(/ /g, "\u00a0");
  return `${nb(start.format(startFormat))} – ${nb(end.format("MMM D, YYYY"))}`;
};

const PeriodMenu = ({ value, onChange }) => (
  <Dropdown className="results-period-menu" align="end">
    <Dropdown.Toggle variant="" className="results-period-menu__toggle" aria-label={`Time period: last ${value} days`}>
      <span className="results-period-menu__range">{rangeLabel(value)}</span>
      <span className="results-period-menu__label">
        Last {value}&nbsp;days
        <ChevronDown size={16} strokeWidth={2} aria-hidden="true" />
      </span>
    </Dropdown.Toggle>
    <Dropdown.Menu className="results-period-menu__list">
      {PERIODS.map((period) => (
        <Dropdown.Item
          key={period.days}
          as="button"
          type="button"
          active={period.days === value}
          aria-current={period.days === value ? "true" : undefined}
          onClick={() => onChange(period.days)}
        >
          Last {period.days} days
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

export default PeriodMenu;
